import SystemIcon from './SystemIcon';
import Card from '../../../components/Card/CardTS';
import CardFooter from '../../../components/Card/CardFooterTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Ink from 'react-ink';
import React, { useState, useEffect } from 'react';
import SystemSettingsIcon from '../SystemSettingsIcon/SystemSettingsIconTS';
import WarningIcon from '@material-ui/icons/WarningRounded';
import BuildIcon from '@material-ui/icons/Build';
import Opacity from '@material-ui/icons/Opacity';
import WiseneCardIcon from '../WiseneCardIcon/WiseneCardIcon.jsx';
import { cardTitle } from '../../../assets/jss/material-dashboard-pro-react-types';
import dashboardStyle from '../../../assets/jss/material-dashboard-pro-react/views/dashboardStyle';
import TextLoop from 'react-text-loop';
import { CSSProperties } from '@material-ui/styles';
import { ISystem } from '../../helpers/interfaces';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle, sweetAlertBigStyle } from '../../helpers/CustomStyles';
import { colorMap } from '../../helpers/GlobalVariables';
import './ShortStatusContent.css';
import WeatherConditionsBox from '../Weather/WeatherConditionsBox';
import WeatherForecast from '../../components/Weather/Weather';
import WeatherIcon from '../Weather/WeatherIcon';
import WeatherTable from '../Weather/WeatherTable';
import WeatherChart from '../Weather/WeatherChart';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import ErrorText from '../ErrorComponent/ErrorText';
import SystemDocumentationCard from '../SystemDocumentationCard/SystemDocumentationCard'
import RainstormModeCard from '../RainstormModeCard/RainstormModeCard';
import TestNotificationCard from '../TestNotificationCard/TestNotificationCard';
import ServiceModeCard from '../ServiceModeCard/ServiceModeCard';
import ResetSensorErrorCountsSystemCard from '../ResetSensorErrorCounts/ResetSensorErrorCountsSystemCard';
import SystemNotificationsCard from '../SystemNotificationsCard/SystemNotificationsCard';
// import { getSystemReport } from '../../stores/actions/exportActions';

const textDarkGray500: CSSProperties = { color: '#3c4858', fontWeight: 500 };
interface IShortStatusContentProps {
	system: ISystem;
	linkDisabled: boolean;
	showBigWeatherCard?: boolean;
	showSmallWeatherCard?: boolean;
	showSystemDocumentation?: boolean;
	showRainstormMode?: boolean;
	showServiceMode?: boolean;
	showTestNotication?: boolean;
	showW2Website?: boolean;
	showSystemGraph?: boolean;
	showResetSensorErrors?: boolean;
	showNotificaitons: boolean;
	mobileView: boolean;
	systemFiles: any;
	accountCategory: string;
	serviceModeSettingSuccess: boolean;
	settingNotificationsSuccess: boolean;
	// getSystemReport: (sysID, sysName) => void;
}

const style = {
	cardTitle,
	cardCategory: dashboardStyle.cardCategory,
	stats: dashboardStyle.stats,
};

const measurementsOutdatedStyle: CSSProperties = { padding: '0', fontWeight: 500, color: '#f44336' };
const serviceModeActiveStyle: CSSProperties = {
	padding: '0',
	fontWeight: 700,
	color: '#ff9800',
	display: 'inline-flex',
	alignItems: 'center',
	gap: '4px',
	minWidth: 0,
};
const rainstormModeActiveStyle: CSSProperties = {
	padding: '0',
	fontWeight: 700,
	color: '#00acc1',
	display: 'inline-flex',
	alignItems: 'center',
	gap: '4px',
	minWidth: 0,
};
const maintenanceActiveStyle: CSSProperties = {
	padding: '0',
	fontWeight: 700,
	color: '#f44336',
	display: 'inline-flex',
	alignItems: 'center',
	gap: '4px',
	minWidth: 0,
};

const ShortStatusContent = (props: IShortStatusContentProps) => {
	const { system, showBigWeatherCard, showSmallWeatherCard, showSystemDocumentation, showRainstormMode, showServiceMode, showTestNotication, 
			showW2Website, showSystemGraph, showResetSensorErrors, showNotifications, mobileView, systemFiles, accountCategory, serviceModeSettingSuccess, settingNotificationsSuccess } = props;
	const { name, overallStatusOk, accountRole } = system;
	const [confirmationWindow, setConfirmationWindow] = useState(null);
	const [showWeatherDetails, setShowWeatherDetails] = useState(true);
	const maintenance: string = overallStatusOk ? 'System OK' : 'Maintenance needed.';
	const iconMaintenance: JSX.Element = !overallStatusOk ? <WarningIcon /> : null;
	const cardIconStyle: CSSProperties = { cursor: 'pointer', position: 'relative' };
	const h3Style: CSSProperties = { ...cardTitle, minHeight: '70px' };
	const inkProps = {
		duration: 400,
		radius: 1250,
		inkStyle: { color: 'white' },
	};
    const iconColor = colorMap[system.NodesHighestThreatLevelActiveNonobstructed];
	let threatExceeded: string = '';
	let iconThreatExceeded: JSX.Element = null;
	if (system.NodesHighestThreatLevelActiveNonobstructed !== 'unknown_or_NA' && system.NodesHighestThreatLevelActiveNonobstructed !== 'none') {
		threatExceeded = `Threshold: ${system.NodesHighestThreatLevelActiveNonobstructed}`;
		iconThreatExceeded = <InfoIcon />;
	}
	const lostSince = system.deviceLost ? system.deviceLostSince : null;
  	const deviceLostTimestamp = lostSince ? (new Date(lostSince)).toLocaleString('sv-SE').replace('T', ' ') : "--";
	const deviceLostMessage = "Device lost. Since: " + deviceLostTimestamp;
	const outdatedMeasurementsMessage: string | null = system.outdatedMeasurements ? 'Outdated measurements' : null;
	const serviceModeMessage: string | null = system.serviceModeNow
		? `Service mode active until: ${(new Date(system.serviceModeEnd)).toLocaleString('sv-SE').replace('T', ' ')}`
		: null;
	const rainstormModeMessage: string | null = system.rainstormModeNow
		? `Rainstorm mode active until: ${(new Date(system.rainstormModeEnd?.Time)).toLocaleString('sv-SE').replace('T', ' ')}`
		: null;
	const activeModeMessages: JSX.Element[] = [];
	if (!overallStatusOk) {
		activeModeMessages.push(
			<div key='maintenance' style={maintenanceActiveStyle}>
				<WarningIcon style={{ color: '#f44336', flexShrink: 0 }} />
				{maintenance}
			</div>
		);
	}
	if (system.deviceLost) {
		activeModeMessages.push(<div key='device-lost' style={measurementsOutdatedStyle}>{deviceLostMessage}</div>);
	}
	if (system.outdatedMeasurements) {
		activeModeMessages.push(<div key='outdated-measurements' style={measurementsOutdatedStyle}>{outdatedMeasurementsMessage}</div>);
	}
	if (system.serviceModeNow) {
		activeModeMessages.push(
			<div key='service-mode' style={serviceModeActiveStyle}>
				<BuildIcon style={{ color: '#ff9800', flexShrink: 0 }} />
				{serviceModeMessage}
			</div>
		);
	}
	if (system.rainstormModeNow) {
		activeModeMessages.push(
			<div key='rainstorm-mode' style={rainstormModeActiveStyle}>
				<Opacity style={{ color: '#00acc1', flexShrink: 0 }} />
				{rainstormModeMessage}
			</div>
		);
	}

	useEffect(() => {
		const wrapper = document.querySelector('#weatherWrapper');
		wrapper?.addEventListener('scroll', handleScroll);
		if (mobileView && wrapper) {
			wrapper.scrollLeft = 1;
		}
		return () => {
			wrapper?.removeEventListener('scroll', handleScroll);
		};
	}, [mobileView]);

	const handleScroll = (e) => {
		const wrapper = document.querySelector('#weatherWrapper') as HTMLDivElement;
		// whole element:
		const scrollWidth = e.target.scrollWidth;
		// current visible container width:
		const clientWidth = e.target.clientWidth;

		if (e.target.scrollLeft < 1) {
			wrapper.scrollLeft = 1;
		}
		if (e.target.scrollLeft > scrollWidth - clientWidth - 1) {
			wrapper.scrollLeft = scrollWidth - clientWidth - 1;
		}
	};

	const hideRemoveSystemConfirmation = () => {
		setConfirmationWindow(null);
	};

	const weather = system.weatherReport.Valid ? (JSON.parse(system.weatherReport.String) as WeatherForecast) : null;
	const daily = weather?.daily?.list;
	let icon;
	let description;
	let hourly;
	let temp;
	let pop;
	let dt;
	let snow;
	let rain;
	 if (daily) {
		icon = daily[0]?.weather[0]?.icon;
		description = daily[0]?.weather[0]?.description;
		hourly = weather?.hourly?.list;
		temp = daily[0]?.temp;
		pop = daily[0]?.pop;
		dt = daily[0]?.dt;
		snow = daily[0]?.snow;
		rain = daily[0]?.rain;
	
	 }

	const renderSmallWeatherCard = (showSmallWeatherCard: boolean): JSX.Element => {
		if (!weather || !daily) return null;
		if (!showSmallWeatherCard) return null;
		return (
			<div style={{ display: 'flex', justifyContent: 'space-around' }}>
				<WeatherIcon description={description} icon={icon} />
				<WeatherConditionsBox dt={dt} description={description} temp={temp} pop={pop} rain={rain} snow={snow} />
			</div>
		);
	};

	const renderBigWeatherCard = (showBigWeatherCard: boolean): JSX.Element => {
		if (!weather || !daily) return null;
		if (!showBigWeatherCard) return null;
		return (
			<div id='weatherWrapper' style={{ overflowX: 'auto', overflowY: 'hidden' }}>
				<div style={{ ...textDarkGray500, marginBottom: '10px' }}>Daily</div>
				<WeatherTable weatherConditions={daily} showWeatherDetails={showWeatherDetails} />
				<div
					style={{
						minWidth: '925px',
						opacity: showWeatherDetails ? '0' : '1',
						height: showWeatherDetails ? '0px' : '210px',
						transition: '0.3s',
					}}
				>
					<div style={{ ...textDarkGray500, marginTop: '25px' }}>Today details</div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<WeatherIcon description={description} icon={icon} />
						<div style={{ margin: '0 16px' }}>
							<WeatherConditionsBox dt={dt} description={description} temp={temp} pop={pop} rain={rain} snow={snow} />
						</div>
						{/* 232px - weather icon and weather condition box total width */}
						<div style={{ flexGrow: 1, height: '200 px', width: 'calc(100% - 232px)' }}>
							<WeatherChart data={hourly} />
						</div>
					</div>
				</div>
			</div>
		);
	};

	const renderWeatherCards = (
		weather: WeatherForecast | undefined,
		showSmallWeatherCard: boolean,
		showBigWeatherCard: boolean
	): JSX.Element => {
		if (!weather) return null;
		try {
			return (
				<ErrorComponent Children message='Weather data cannot be showed.'>
					{renderSmallWeatherCard(showSmallWeatherCard)}
					{renderBigWeatherCard(showBigWeatherCard)}
				</ErrorComponent>
			);
		} catch (error) {
			return <ErrorText message='Weather data cannot be showed.' />;
		}
	};

	const handleWeatherToggle = (): void => {
		setShowWeatherDetails(!showWeatherDetails);
	};

	const showSystemDocumentationCard = (): void => {
		setConfirmationWindow(
				<SweetAlert title=''
					key="system-docs-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertBigStyle}>
					<SystemDocumentationCard
						// classes={classes}
						hideAlert={hideRemoveSystemConfirmation}
						systemVersion={system.systemVersion}
						systemFiles={systemFiles}
					/>
				</SweetAlert>
		);
	};

	const showRainstormModeCard = (): void => {
		setConfirmationWindow(
				<SweetAlert title=''
					key="system-rainstorm-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertStyle}>
					<RainstormModeCard
						systemID={system.ID}
						hideAlert={hideRemoveSystemConfirmation}
						// rainstormModeNow={system.rainstormModeNow}
						// rainstormModeEnd={system.rainstormModeEnd.Time}
					/>
				</SweetAlert>
		);
	};
	
	const showTestNoticationCard = (): void => {
		setConfirmationWindow(
				<SweetAlert title=''
					key="test-notification-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertStyle}>
					<TestNotificationCard
						systemID={system.ID}
						systemVersion={system.systemVersion}
						hideAlert={hideRemoveSystemConfirmation}
					/>
				</SweetAlert>
		);
	};

	const showServiceModeCard = (): void => {
		setConfirmationWindow(
				<SweetAlert title=''
					key="service-mode-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertStyle}>
					<ServiceModeCard
						systemID={system.ID}
						systemVersion={system.systemVersion}
						hideAlert={hideRemoveSystemConfirmation}
					/>
				</SweetAlert>
		);
	};

	const showResetSensorErrorsCard = (): void => {
		setConfirmationWindow(
				<SweetAlert title=''
					key="reset-sensor-errors-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertStyle}>
					<ResetSensorErrorCountsSystemCard
						systemID={system.ID}
						hideAlert={hideRemoveSystemConfirmation}
					/>
				</SweetAlert>
		);
	};

	const showNotificationsCard = (): void => {
		console.log('showNotificationsCard');
		setConfirmationWindow(
				<SweetAlert title=''
					key="notifications-alert-card"
					onCancel={hideRemoveSystemConfirmation}
					onConfirm={hideRemoveSystemConfirmation}
					showConfirm={false}
					style={sweetAlertStyle}>
					<SystemNotificationsCard
						accountCategory={accountCategory}
						systemID={system.ID}
						systemVersion={system.systemVersion}
						updatedViaWebsiteAt={system.updatedViaWebsiteAt}
						notificationsEmailOn={system.notificationsEmailOn}
						notificationsPushOn={system.notificationsPushOn}
						notificationsSmsOn={system.notificationsSmsOn}
						hideAlert={hideRemoveSystemConfirmation}
					/>
				</SweetAlert>
		);
	};

	try {
		return (
			<ErrorComponent Children message='System data cannot be showed.'>
				{confirmationWindow}
				<NavLink exact to={`/systems/${system.ID}/dashboard`} activeStyle={{ cursor: 'default' }}>
					<Card data-testid='shortStatusContent'>
						<CardHeader color='info' icon>
							<WiseneCardIcon color={iconColor} style={cardIconStyle}>
								<SystemIcon />
								<Ink {...inkProps} />
							</WiseneCardIcon>
							<p style={style.cardCategory}>System</p>
							<h3 style={h3Style}>{name}</h3>
							{renderWeatherCards(weather, showSmallWeatherCard, showBigWeatherCard)}
							<SystemSettingsIcon
								accountCategory={accountCategory}
								accountRole={accountRole}
								system={system}
								handleWeatherToggle={handleWeatherToggle}
								showBigWeatherCard={showBigWeatherCard}
								isWeatherDataValid={!!weather}
								showRainstormModeCard={showRainstormModeCard}
								showTestNoticationCard={showTestNoticationCard}
								showTestNoticationIcon={showTestNotication}
								showSystemDocumentationCard={showSystemDocumentationCard}
								showSystemDocumentationIcon={showSystemDocumentation}
								showRainstormModeIcon={showRainstormMode}
								showServiceModeIcon={showServiceMode}
								showServiceModeCard={showServiceModeCard}
								showW2WebsiteIcon={showW2Website}
								showSystemGraphIcon={showSystemGraph}
								showResetSensorErrorsIcon={showResetSensorErrors}
								showResetSensorErrorsCard={showResetSensorErrorsCard}
								showWeatherDetails={showWeatherDetails}
								serviceModeSettingSuccess={serviceModeSettingSuccess}
								settingNotificationsSuccess={settingNotificationsSuccess}
								showNotificationsIcon={showNotifications}
								showNotificationsCard={showNotificationsCard}
								// getSystemReport={props.getSystemReport}
								
								
							/>
						</CardHeader>
						<CardFooter stats>
							<GridContainer style={style.stats}>
								{ activeModeMessages.length > 0 ? (
									<GridItem xs style={{ padding: '0 0 0 15px', minWidth: 0 }}>
										{activeModeMessages.length > 1 ? (
											<TextLoop interval={5000} adjustingSpeed={500} noWrap={false} className='system-text-loop'>
												{activeModeMessages}
											</TextLoop>
										) : activeModeMessages[0]}
									</GridItem>
								) : (
									<GridItem xs style={{ padding: '0 0 0 15px', minWidth: 0 }}>
										{iconMaintenance}
										{maintenance}
									</GridItem>
								)}
								<GridItem style={{ padding: '0 15px 0 0', textAlign: 'right', minWidth: 0, flexShrink: 0 }}>
									{iconThreatExceeded}
									{threatExceeded}
								</GridItem>
							</GridContainer>
						</CardFooter>
					</Card>
				</NavLink>
			</ErrorComponent>
		);
	} catch (error) {
		return <ErrorText message={'Error'} />;
	}
};

const mapStateToProps = (state) => {
	return {
		mobileView: state.dashboard.mobileView,
		accountCategory: state.login.accountCategory,
		serviceModeSettingSuccess: state.dashboard.serviceModeSettingSuccess,
		settingNotificationsSuccess: state.dashboard.settingNotificationsSuccess,
	};
};

const actions = {
	// getSystemReport,
};

export default connect(mapStateToProps, actions)(ShortStatusContent);
